import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { Button, Divider, Form, Input, Modal, Select } from 'semantic-ui-react';
import { useStore } from '../../stores/store';
import {
  ApproveOptions1,
  DenyOptions,
  moveOptions,
  VerifyOptions,
} from '../options/otherOptions/approveOptions';
import agent from './../../api/agent';
import { toast } from 'react-toastify';
import { userLanguage } from '../userLanguageSchema/userLanguage';
import { optionsInterface } from '../../models/tabverify';
import { Activity } from '../../models/activity';
import { assetConditionOptions } from '../../../features/Dashboard/Receiving/DashboardTagContainer';

function ApproveModal() {
  const {
    dashboardStore: { dashboard, DenialModalOpen },
    activityStore,
    commonStore,
    userStore: { user },
    vaultStore: {
      getVaultList,
      vaultList,
      getRackList,
      getShelfList,
      rackList,
      shelfList,
      getPigeonList,
      pigeonList,
    },
    viewStore: { deleteCircuit },
  } = useStore();
  const { selectedActivity } = activityStore;
  const [, setOpen] = useState(false);
  const [comments, setComments] = useState('');
  const [commentsDropdownValue, setCommentsDropdownValue] = useState('');
  const [vaultOptions, setVaultOptions] = useState<optionsInterface[]>([]);
  const [rackOptions, setRackOptions] = useState<optionsInterface[]>([]);
  const [selectedShelfOption, setSelectedShelfOption] = useState<
    optionsInterface[]
  >([]);
  const [itemData, setItemData] = useState<Activity | undefined>(undefined);
  // const [isAllowed, setIsAllowed] = useState<boolean>(true);
  const vaultId = useRef<string>('');

  useEffect(() => {
    if (vaultList.length === 0) getVaultList();
  }, [vaultList.length, getVaultList]);

  useEffect(() => {
    setItemData(selectedActivity);
    // eslint-disable-next-line
  }, [selectedActivity]);

  useEffect(() => {
    if (vaultList.length > 0) {
      const tempVaultOptions = vaultList.map((v) => {
        return {
          key: v.id,
          text: v.name,
          value: v.name,
        };
      });
      setVaultOptions(tempVaultOptions);
    } else {
      setVaultOptions([]);
      setRackOptions([]);
      setSelectedShelfOption([]);
    }
    // eslint-disable-next-line
  }, [vaultList]);

  useEffect(() => {
    if (rackList.length > 0) {
      const tempRack = rackList?.map((x) => ({
        key: x,
        text: x,
        value: x,
      }));
      setRackOptions(tempRack);
    } else {
      setRackOptions([]);
      setSelectedShelfOption([]);
    }
    // eslint-disable-next-line
  }, [rackList]);

  useEffect(() => {
    if (shelfList.length > 0) {
      const tempShelf = shelfList?.map((x) => ({
        key: x,
        text: x,
        value: x,
      }));
      setSelectedShelfOption(tempShelf);
    } else {
      setSelectedShelfOption([]);
    }
    // eslint-disable-next-line
  }, [shelfList]);

  const handleChange = (e: SyntheticEvent, data: any) => {
    setComments(data.value);
    setCommentsDropdownValue('');
  };

  useEffect(() => {
    if (itemData?.physical_location_vault && vaultList.length > 0) {
      const tempLocal = vaultList.filter(
        (vaultdata) => vaultdata.name === itemData.physical_location_vault,
      );
      getRackList({ vaultId: tempLocal[0]?.id });
      vaultId.current = tempLocal[0]?.id;
    }
    // eslint-disable-next-line
  }, [itemData?.physical_location_vault, vaultList]);

  useEffect(() => {
    if (itemData?.physical_location_rack && vaultId.current !== '') {
      getShelfList({
        vaultId: vaultId.current,
        rackNo: itemData.physical_location_rack,
      });
    }
    // eslint-disable-next-line
  }, [itemData?.physical_location_rack, vaultId.current]);

  useEffect(() => {
    getPigeonList();
  }, [getPigeonList]);

  const handleTagChange = (e: SyntheticEvent, data: any) => {
    if (itemData !== undefined) {
      let newArr = {
        ...itemData,
        movementdate: new Date().toISOString(),
        // asset_tracking_status: 'Tagged',
        [data.name]: data.value,
      };

      if (data.name === 'physical_location_vault') {
        const gpsDataLocal = vaultList.filter(
          (vaultdata) => vaultdata.name === data.value,
        );
        newArr = {
          ...newArr,
          global_positioning_system:
            gpsDataLocal[0]?.gpsLocation || itemData.global_positioning_system,
          physical_location_rack: '',
          physical_location_shelf: '',
        };
        setRackOptions([]);
        setSelectedShelfOption([]);
      } else if (data.name === 'physical_location_rack') {
        newArr = {
          ...newArr,
          physical_location_shelf: '',
        };
        setSelectedShelfOption([]);
      }
      setItemData(newArr);
    }
  };

  // useEffect(() => {
  //   (async () => {
  //     if (
  //       commonStore.hfcCustomerChanges &&
  //       itemData !== undefined &&
  //       itemData?.physical_location_vault !== '' &&
  //       itemData?.physical_location_shelf !== '' &&
  //       itemData?.physical_location_rack !== ''
  //     ) {
  //       const payload = {
  //         customerName: user?.customerName || '',
  //         vaultName: itemData?.physical_location_vault.split('/')[0],
  //         rackNo: itemData?.physical_location_rack,
  //         shelfNo: itemData?.physical_location_shelf,
  //       };
  //       const allowed = await agent.HFC.tagValidationHfc(payload, {
  //         moveTo: true,
  //       });
  //       if (!allowed.data?.toLocaleLowerCase().includes('okay')) {
  //         toast.info(allowed.data);
  //         setIsAllowed(false);
  //       } else {
  //         setIsAllowed(true);
  //       }
  //     }
  //   })();
  //   // eslint-disable-next-line
  // }, [itemData?.physical_location_shelf, commonStore.hfcCustomerChanges]);

  const setPhysicalCaseCount = (e: any, data: any) => {
    if (itemData !== undefined) {
      const newArr = {
        ...itemData,
        [data.name]: data.value,
      };
      setItemData(newArr);
    }
  };

  const verifyHandler = async (inward: any) => {
    try {
      let params = {
        id: inward?.id,
        verify: dashboard.ApproveDenialHeader === 'Verify',
        comment: comments || commentsDropdownValue,
      };
      let result = await agent.Inwards.inwardVerifyUpdate(params);
      if (result?.data) {
        if (params.verify) {
          commonStore.updateHistoryAlonePOST(
            `Inward asset verified for ${selectedActivity?.title} by ${user?.displayName}`,
            selectedActivity?.id,
          );
          await agent.InventoryDelivery.OrderTrackingStatus(
            activityStore.selectedActivity?.id,
            'Inward Asset Verified',
          );
          dashboard.valueForL3Orders = 'Approve';
        } else {
          commonStore.updateHistoryAlonePOST(
            `Inward asset verification denied for ${selectedActivity?.title} by ${user?.displayName} due to reason: ${
              commentsDropdownValue ? commentsDropdownValue : comments
            } `,
            selectedActivity?.id,
          );
          await agent.InventoryDelivery.OrderTrackingStatus(
            activityStore.selectedActivity?.id,
            'Inward Asset denied during verification',
          );
          dashboard.valueForL3Orders = 'Inward Request';
        }
        // toast.success("Verified Successfully");
      }
    } catch {
      toast.error('Something went wrong');
    }
  };

  const approveHandler = async (inward: any) => {
    try {
      let params = {
        id: inward.id,
        approve: dashboard.ApproveDenialHeader === 'Approve',
        comment: comments || commentsDropdownValue,
      };
      let result = await agent.Inwards.inwardApproveUpdate(params);
      if (result?.data) {
        if (params.approve) {
          commonStore.updateHistoryAlonePOST(
            `Inward asset approved by ${user?.displayName} to assign a picker`,
            selectedActivity?.id,
            undefined,
            true,
            true,
          );
          await agent.InventoryDelivery.OrderTrackingStatus(
            activityStore.selectedActivity?.id,
            'Inward Asset Approved',
          );
          dashboard.valueForL3Orders = 'Picker Assign';
        } else {
          commonStore.updateHistoryAlonePOST(
            `Inward asset approval denied for ${selectedActivity?.title} to assign a picker by ${user?.displayName} due to reason: ${
              commentsDropdownValue ? commentsDropdownValue : comments
            }`,
            selectedActivity?.id,
            undefined,
            true,
            true,
          );
          await agent.InventoryDelivery.OrderTrackingStatus(
            activityStore.selectedActivity?.id,
            'Inward Asset denied during approval',
          );
          dashboard.valueForL3Orders = 'Verify';
        }
        // toast.success("Approved Successfully");
      }
    } catch {
      toast.error('Something went wrong');
    }
  };

  const moveToValutHandler = async (inward: any) => {
    try {
      let params = {
        id: inward.id,
        comment: comments || commentsDropdownValue,
      };
      let result = await agent.Inwards.inwardMoveToVaultUpdate(params);
      if (result?.data) {
        activityStore.inwardFetchTableDetails('', 1, 'MoveToVault');
        commonStore.updateHistoryAlonePOST(
          `Inward asset - ${selectedActivity?.title} moved to vault by ${user?.displayName}`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
        await agent.InventoryDelivery.OrderTrackingStatus(
          activityStore.selectedActivity?.id,
          'Inward Asset Moved to Vault',
        );
        await agent.InventoryDelivery.AssetTrackingStatus(
          activityStore.selectedActivity?.id,
          'Asset returned back to the Vault successfully.',
        );
      }
    } catch {
      toast.error('Something went wrong');
    }
  };

  const saveFunction = async () => {
    let inward = selectedActivity?.inwards?.filter(
      (i) => i.isActive === true,
    )?.[0];
    if (inward) {
      if (dashboard.valueForL3Orders === 'Verify') {
        verifyHandler(inward);
      } else if (dashboard.valueForL3Orders === 'Approve') {
        approveHandler(inward);
      } else if (dashboard.valueForL3Orders === 'Move To Vault') {
        // let allowed: any = {
        //   data: '',
        // };
        // if (commonStore.hfcCustomerChanges) {
        //   const payload = {
        //     customerName: user?.customerName || '',
        //     vaultName: itemData?.physical_location_vault.split('/')[0] || '',
        //     rackNo: itemData?.physical_location_rack || '',
        //     shelfNo: itemData?.physical_location_shelf || '',
        //   };
        //   allowed = await agent.HFC.tagValidationHfc(payload, { moveTo: true });
        // }
        // if (
        //   allowed.data !== '' &&
        //   !allowed.data?.toLocaleLowerCase().includes('okay')
        // ) {
        //   toast.info(allowed.data);
        // } else {
        if (itemData !== undefined) {
          const gpsDataLocal = vaultList.filter(
            (vaultdata) => vaultdata.name === itemData.physical_location_vault,
          );
          const TagData = {
            id: itemData.id || '',
            physical_location_rack: itemData.physical_location_rack,
            physical_location_vault: itemData?.physical_location_vault,
            physical_location_shelf: itemData.physical_location_shelf,
            global_positioning_system:
              gpsDataLocal[0]?.gpsLocation ||
              itemData.global_positioning_system,
            physical_sensor_RFID: itemData.physical_sensor_RFID || itemData.id,
            physical_sensor_NFC: itemData.physical_sensor_NFC || itemData.id,
            physical_sensor_qrcode:
              itemData.physical_sensor_qrcode || itemData.id,
            physical_sensor_barcode:
              itemData.physical_sensor_barcode || itemData.id,
            assetCondition: itemData.assetCondition,
            calculated_category: itemData.calculated_category || 0,
            synopsis: itemData.synopsis,
          };
          await agent.Activities.physicalAsset(itemData.id, TagData);
        }
        moveToValutHandler(inward);
        if (commonStore.hfcCustomerChanges) {
          deleteCircuit({ itemId: itemData?.id });
        }
        // }
      }
      DenialModalOpen(false, '', false, '');
    }
  };

  const enableSave = () => {
    let disable = false;
    if (
      dashboard.L2CardValueOrders === 'Inward' &&
      dashboard.valueForL3Orders === 'Move To Vault'
    ) {
      disable =
        itemData === undefined ||
        itemData?.physical_location_vault === '' ||
        itemData?.physical_location_rack === '' ||
        itemData?.physical_location_shelf === '' ||
        itemData?.assetCondition === '' ||
        itemData?.assetCondition === undefined ||
        itemData?.synopsis.length === 0 ||
        // !isAllowed ||
        (comments?.length || commentsDropdownValue?.length) < 1;
    } else {
      disable = (comments?.length || commentsDropdownValue?.length) < 1;
    }
    return disable;
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={dashboard.DenialModal}
    >
      <Modal.Header>Reason For {dashboard.ApproveDenialHeader}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form style={{ marginTop: '0px' }}>
            <Form.TextArea
              label="Comments"
              placeholder="Please Specify a reason"
              maxLength="500"
              name="comments"
              value={comments}
              onChange={handleChange}
            />
          </Form>
          <Divider horizontal>Or</Divider>
          <Form>
            <Form.Field
              id="Type"
              options={
                dashboard.ApproveDenialHeader === 'Deny'
                  ? DenyOptions
                  : dashboard.ApproveDenialHeader === 'Approve'
                    ? ApproveOptions1
                    : dashboard.ApproveDenialHeader === 'Verify'
                      ? VerifyOptions
                      : dashboard.ApproveDenialHeader === 'Movement Complete'
                        ? moveOptions
                        : DenyOptions
              }
              control={Select}
              label="Reasons"
              name="comments"
              placeholder=""
              clearable
              value={commentsDropdownValue}
              onChange={(e: any, data: any) => {
                setComments('');
                setCommentsDropdownValue(data.value);
              }}
            />
            {dashboard.L2CardValueOrders === 'Inward' &&
              dashboard.valueForL3Orders === 'Move To Vault' && (
                <>
                  <Form.Field
                    style={{ width: '40vw' }}
                    clearable
                    fluid
                    search
                    selection
                    options={vaultOptions}
                    control={Select}
                    label={
                      (
                        userLanguage[0].Level3InventoryRecievingTagTab
                          ?.IRVTTL02 as any
                      )?.[`${commonStore.language.key}`]
                    } //"Vault"
                    placeholder={
                      (
                        userLanguage[0].Level3InventoryRecievingTagTab
                          ?.IRVTTDD01 as any
                      )?.[`${commonStore.language.key}`]
                    } //"Select Vault"
                    name="physical_location_vault"
                    onChange={handleTagChange}
                    value={itemData?.physical_location_vault!}
                  />
                  <Form.Field
                    style={{ width: '40vw' }}
                    clearable
                    fluid
                    search
                    selection
                    options={rackOptions}
                    name="physical_location_rack"
                    placeholder={'Select Rack'}
                    label={'Select Rack'}
                    control={Select}
                    onChange={handleTagChange}
                    value={itemData?.physical_location_rack!}
                  />
                  <Form.Field
                    style={{ width: '40vw' }}
                    clearable
                    fluid
                    search
                    selection
                    options={selectedShelfOption}
                    name="physical_location_shelf"
                    placeholder={'Select Shelf'}
                    label={'Select Shelf'}
                    control={Select}
                    onChange={handleTagChange}
                    value={itemData?.physical_location_shelf}
                  />
                  <Form.Field
                    style={{ width: '40vw' }}
                    clearable
                    fluid
                    search
                    selection
                    upward
                    options={assetConditionOptions}
                    name="assetCondition"
                    label={'Asset Condition'}
                    control={Select}
                    placeholder={'Evaluate Asset Condition'}
                    onChange={handleTagChange}
                    value={itemData?.assetCondition!}
                  />
                  {commonStore.hfcCustomerChanges && (
                    <>
                      <Form.Field>
                        <label>Physical Case Count</label>
                        <Input
                          style={{ width: '40vw' }}
                          name="calculated_category"
                          type="number"
                          placeholder={'Enter Physical Case Count'}
                          onChange={setPhysicalCaseCount}
                          value={itemData?.calculated_category!}
                        />
                      </Form.Field>
                      <Form.Field
                        style={{ width: '40vw' }}
                        clearable
                        fluid
                        search
                        selection
                        upward
                        options={pigeonList}
                        name="synopsis"
                        label={'Pigeon Hole'}
                        control={Select}
                        placeholder={'Pigeon Hole'}
                        onChange={handleTagChange}
                        value={itemData?.synopsis!}
                      />
                    </>
                  )}
                </>
              )}
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => DenialModalOpen(false, '', false, '')}
        >
          Cancel
        </Button>
        <Button
          content="Save"
          labelPosition="right"
          icon="checkmark"
          onClick={saveFunction}
          positive
          disabled={enableSave()}
        />
      </Modal.Actions>
    </Modal>
  );
}
export default observer(ApproveModal);
